import { useMutation } from '@tanstack/react-query'

import { createFreeeAuthForAccounting } from '@src/api'
import { DefaultApiCreateFreeeAuthForAccountingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useCreateFreeeAuthForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiCreateFreeeAuthForAccountingRequest) =>
      createFreeeAuthForAccounting(axiosInstance, params),
  })
}
